import { inject, Injectable } from "@angular/core";
import { ClickkerHttpClient } from "./ClickkerHttpClient";
import { environment } from "../../../environments/environment";
import { HttpHeaders } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export abstract class CloudHttpClient extends ClickkerHttpClient {
    private authService: AuthService = inject(AuthService);

    constructor() {
        super(environment.clickkerCloud.api.url, false)
    }

    protected override getHeaders(): HttpHeaders | undefined {
        const userInformation = this.authService.getUserInformationFromCache();
        return userInformation ? new HttpHeaders({"TenantID": userInformation.currentTenant.id}) : undefined;
    }
}
